/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Button, Grid, Paper, ThemeProvider } from "@mui/material";
import { SEText } from "../../../../components/SEText";
import SEFilterSelect from "../../../../components/SEFilterSelect";
import styled from "styled-components";
import { RiSearchLine } from "react-icons/ri";
import { Controller, useForm } from "react-hook-form";
import {
  formatStringArray,
  sortArrayByDirection,
  sortArrayByProp,
} from "../../../../utils/utils";
import { AnotacaoOrientacaoInterface } from "../../../../interfaces";
import { useQuery } from "react-query";
import { AnotacaoOrientacaoService } from "../services";
import useRenderFormStore from "../../stores/useRenderFormStore";
import { removeEmpty } from "../../../../../utils/utils";
import { BaSeDialogContext } from "@base/react";
import useFormMutation from "../../hooks/useFormMutation";
import EditorQuill from "../../../../components/EditorQuill";
import theme from "../../../../mui-theme";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router";
import { SEFormUserAction } from "../../../../components/SEFormUserAction";
import SEControlledInput from "../../../../components/SEControlledInput";

const CustomIcon = styled(RiSearchLine)(({ theme }) => ({
  fill: theme.palette.primary.main,
  height: 26,
  width: 26,
  top: "calc(50% - .75em) !important",
}));

const FormularioAnotacaoOrientacao = () => {
  const { showModal } = React.useContext(BaSeDialogContext);
  const history = useHistory();
  const { id } = useParams<{ id: string }>();

  const {
    data: filterOptions,
    // isLoading: isLoadingOptions,
    // isError: isErrorOptions,
  } = useQuery({
    queryFn: () => AnotacaoOrientacaoService.getOptions(),
    queryKey: ["getOptions"],
    refetchOnMount: false,
  });

  const { formData: editFormData, setFormData: setEditFormData } =
    useRenderFormStore();

  const [formData, setFormData] = useState<AnotacaoOrientacaoInterface>(
    editFormData?.id
      ? editFormData
      : {
          id: undefined,
          uf: undefined,
          titulo: "",
          descricao: "",
          tipo: "",
          status: undefined,
          tipoAtendente: undefined,
        }
  );

  const { control, handleSubmit, reset } = useForm<AnotacaoOrientacaoInterface>(
    {
      defaultValues: formData,
    }
  );
  const onResetFields = () => {
    reset({
      id: undefined,
      uf: undefined,
      titulo: "",
      descricao: "",
      tipo: "",
      status: undefined,
      tipoAtendente: undefined,
    });
  };

  const goBack = () => {
    history.push(`/tabelas-de-controle/anotacao-orientacao`);
  };

  useEffect(() => {
    const fetchDataIfNecessary = async () => {
      if (id) {
        if (!editFormData) {
          const data = await AnotacaoOrientacaoService.read(id);
          setEditFormData(data);
          reset(data);
        } else {
          setFormData(editFormData);
        }
      }
    };

    fetchDataIfNecessary();
  }, [id, editFormData, setFormData]);

  const { createMutation, updateMutation } = useFormMutation({
    showModal,
    service: AnotacaoOrientacaoService,
    onCloseModalSuccess: () => {
      onResetFields();
      goBack();
    },
    onCloseModalUpdate: () => goBack(),
  });

  const submitForm = async (dataForm: AnotacaoOrientacaoInterface) => {
    if (dataForm.id) {
      await updateMutation(removeEmpty(dataForm)).then();
    } else {
      await createMutation(removeEmpty(dataForm));
    }
  };

  return (
    <Paper
      sx={{
        display: "flex",
        alignItems: "center",
        padding: 2,
      }}
    >
      <ThemeProvider theme={theme}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <SEText
              as="h2"
              size={"medium"}
              font="Mulish"
              weight="bold"
              color="#7B80FF"
            >
              {editFormData?.id ? "Editar" : "Incluir"}
            </SEText>
          </Grid>

          <Grid container item spacing={3}>
            <Grid item md={6}>
              <Controller
                control={control}
                name="uf"
                rules={{ required: "Este campo é obrigatório" }}
                render={({
                  field: { value, onChange },
                  fieldState: { error },
                }) => (
                  <SEFilterSelect
                    id={"uf"}
                    defaultOption={"Selecione uma das opções"}
                    IconComponent={CustomIcon}
                    label="UF *"
                    value={value}
                    onChange={onChange}
                    options={sortArrayByProp(filterOptions?.ufs, "sigla")}
                    displayField="sigla"
                    error={error}
                  />
                )}
              />
            </Grid>

            <Grid item md={6}>
              <Controller
                control={control}
                name="tipo"
                rules={{ required: "Este campo é obrigatório" }}
                render={({
                  field: { value, onChange },
                  fieldState: { error },
                }) => (
                  <SEFilterSelect
                    customLabel={formatStringArray}
                    defaultOption={"Selecione uma das opções"}
                    IconComponent={CustomIcon}
                    label="Tipo de modelo *"
                    value={value}
                    onChange={onChange}
                    options={filterOptions?.tipo}
                    error={error}
                  />
                )}
              />
            </Grid>
          </Grid>

          <Grid item md={6}>
            <SEControlledInput
              control={control}
              name={"titulo"}
              label={"Título *"}
              placeholder={"Digite o título"}
              maxLength={50}
              showMaxLength={true}
            />
          </Grid>

          <Grid item md={6}>
            <Controller
              control={control}
              name="tipoAtendente"
              rules={{ required: "Este campo é obrigatório" }}
              render={({
                field: { value, onChange },
                fieldState: { error },
              }) => (
                <SEFilterSelect
                  customLabel={formatStringArray}
                  defaultOption={"Selecione uma das opções"}
                  IconComponent={CustomIcon}
                  label="Perfil Atendente *"
                  value={value}
                  onChange={onChange}
                  options={sortArrayByDirection(filterOptions?.tipoAtendente)}
                  error={error}
                />
              )}
            />
          </Grid>

          <Grid item md={12}>
            <Controller
              name="descricao"
              control={control}
              rules={{ required: "Este campo é obrigatório" }}
              render={({ field, fieldState: { error } }) => (
                <>
                  <EditorQuill
                    label={"Descrição"}
                    required={true}
                    placeholder={
                      "Digite aqui a descrição da anotação ou orientação"
                    }
                    onChange={field.onChange}
                    value={field.value}
                  />
                  {error && (
                    <p style={{ color: "red", marginTop: "8px" }}>
                      {error.message}
                    </p>
                  )}
                </>
              )}
            />
          </Grid>

          <Grid item md={12} display="flex" justifyContent="flex-end" gap={2}>
            <Button variant="outlined" onClick={goBack}>
              Cancelar
            </Button>
            <Button
              style={{
                backgroundColor: "#7B80FF",
                color: "#FFFFFF",
                fontFamily: "Mulish, sans-serif",
              }}
              variant="contained"
              onClick={handleSubmit(submitForm)}
              disabled={false}
            >
              {!!editFormData?.id ? "Editar" : "Incluir"}
            </Button>
          </Grid>

          <Grid item md={12}>
            <SEFormUserAction data={editFormData} />
          </Grid>
        </Grid>
      </ThemeProvider>
    </Paper>
  );
};

export default FormularioAnotacaoOrientacao;
